
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DefaultLayout from '@/components/DefaultLayout.vue';
import J1lSvg from '@/components/Svg-test.vue';
import { DieService } from '../services/die-service';
import { DieTemplate } from '../store/models/DieModel';
import { ValidationHelper } from '../helpers/ValidationHelper';
import MasterLayout from '@/components/MasterLayout.vue';
import { Getter } from 'vuex-class';
import { shapes } from 'konva/types/Shape';
import { Die } from '@/store/models/ItemModel';
import { VLayout } from 'vuetify/lib';

export class TemplateWrapper {
  die: Die = null;
  modifiedSVG: string = '';
  constructor(die) {
    this.die = die;
  }
}

@Component({
  components: { DefaultLayout, J1lSvg, MasterLayout },
  filters: {}
})
export default class extends Vue {
  /* Properties */
  @Prop() dies!: Array<Die>;

  /* Store Actions */

  onSearchClearClicked(searchObj) {
    searchObj.input = '';
  }

  onShapeSelectionValuesChange() {
    this.SearchTemplates();
  }

  /* Watchers */
  @Watch('searchTag.input')
  onSearchTagChange() {
    if (this.searchTag.input == null) {
      this.searchTag.input = '';
    }
    if (this.searchTag.input == this.searchTag.value) return;
    this.waitForSearch(this.searchTag);
  }

  @Watch('searchWidth.input')
  onSearchWidthChange() {
    if (this.searchWidth.input == null) {
      this.searchWidth.input = '';
    }
    if (this.searchWidth.input == this.searchWidth.value) return;
    this.waitForSearch(this.searchWidth);
  }
  @Watch('searchHeight.input')
  onSearchHeightChange() {
    if (this.searchHeight.input == null) {
      this.searchHeight.input = '';
    }
    if (this.searchHeight.input == this.searchHeight.value) return;
    this.waitForSearch(this.searchHeight);
  }

  @Watch('dropdownSearchBy.enum')
  onDropdownSearchByChange() {
    this.searchState = this.dropdownSearchBy.enum;
    console.log(this.searchState);
    this.SearchTemplates();
  }

  @Watch('dies', { deep: true })
  onDiesChanged() {
    if (this.dies) this.getTemplates(this.dies);
  }

  /* Data */

  shapeSelectionItems = [
    { icon: '□', shapeSearchKeywords: ['Square', 'Rectangle'], text: 'Square/Rectangle' },
    { icon: '○', shapeSearchKeywords: ['Circle', 'Oval'], text: 'Circle/Oval' },
    { icon: '⭔', shapeSearchKeywords: ['Special', 'None'], text: 'Special Shape' }
  ];
  shapeSelectionValues = [];

  searchTag = {
    input: '',
    value: ''
  };
  searchWidth = {
    input: '',
    value: ''
  };
  searchHeight = {
    input: '',
    value: ''
  };

  SearchStateEnum = Object.freeze({
    TAG: 0,
    SIZE: 1
  });
  searchState: number = this.SearchStateEnum.TAG;

  dropdownSearchBy = { text: 'Tag', enum: this.SearchStateEnum.TAG };
  sizeSearchThreshold = 0.15;
  shapeDrawer = null;

  initialLoadTemplates: Array<TemplateWrapper> = [];
  currentlyDisplayedTemplates: Array<TemplateWrapper> = [];
  isLoadingInitialTemplates = false;

  getShapesMappedToItems() {
    var items = [];
    this.shapeSelectionValues.forEach(element => {
      var item = this.shapeSelectionItems.filter(e => e.text == element);
      items = items.concat(item);
    });
    return items;
  }

  getShapeSelectedIcons() {
    var listOfShapes = '';
    this.getShapesMappedToItems().forEach(element => {
      listOfShapes += element.icon;
    });
    return listOfShapes;
  }
  getShapesForFilter() {
    var listOfShapes = [];
    var values =
      this.shapeSelectionValues.length == 0
        ? this.shapeSelectionItems
        : this.getShapesMappedToItems();
    values.forEach(selectedShape => {
      listOfShapes = listOfShapes.concat(selectedShape.shapeSearchKeywords);
    });

    return listOfShapes;
  }

  waitForSearch(searchObj) {
    searchObj.value = searchObj.input;
    this.SearchTemplates();
  }

  SearchTemplates() {
    if (this.searchState == this.SearchStateEnum.TAG) {
      this.filterTemplatesOnTagSearchValueChange();
    } else if (this.searchState == this.SearchStateEnum.SIZE) {
      this.filterTemplatesOnHeightWidthSearchValueChange();
    }
  }

  /* Computed */

  /* Loaders */
  async getTemplates(dies: Array<Die>) {
    if (
      this.initialLoadTemplates == null ||
      this.isLoadingInitialTemplates ||
      !dies.length
    )
      return;

    dies.forEach(element => {
      var wrapper = new TemplateWrapper(element);

      if (!element.IsAdvancedDie) {
        wrapper.modifiedSVG = wrapper.die.SVGTrimLineRaster.replaceAll(
          'stroke-width="1"',
          `stroke-width="${3 +
            Math.min(Number(wrapper.die.Height), Number(wrapper.die.Width)) * 6}"`
        );
      } else {
        wrapper.modifiedSVG = wrapper.die.SVGTrimLineRaster.replaceAll(
          'class="svg-trimline"',
          `class="svg-trimline" stroke-width="${1 +
            Math.min(Number(wrapper.die.Height), Number(wrapper.die.Width)) * 1}"`
        );
      }
      this.initialLoadTemplates.push(wrapper);
    });

    this.initialLoadTemplates.sort((a, b) => Number(a.die.Width) - Number(b.die.Width));
    this.currentlyDisplayedTemplates = this.initialLoadTemplates;

    this.isLoadingInitialTemplates = false;
  }

  filterTemplatesOnTagSearchValueChange() {
    console.log('filtering & sorting templates based on Tag...');
    this.currentlyDisplayedTemplates = this.initialLoadTemplates.filter(
      (t: TemplateWrapper) =>
        t.die.Tag.toLowerCase().includes(this.searchTag.value.toLowerCase()) &&
        this.getShapesForFilter().includes(t.die.Shape)
    );
    this.currentlyDisplayedTemplates.sort((a, b) => a.die.Tag.localeCompare(b.die.Tag));
    console.log('finished filtering & sorting.');
  }

  filterTemplatesOnHeightWidthSearchValueChange() {
    console.log('filtering templates based on Height/Width...');
    if (this.searchHeight.value == '' && this.searchWidth.value == '') {
      this.currentlyDisplayedTemplates = this.initialLoadTemplates.filter(
        (t: TemplateWrapper) => this.getShapesForFilter().includes(t.die.Shape)
      );
      this.currentlyDisplayedTemplates.sort((a, b) => a.die.Tag.localeCompare(b.die.Tag));
    } else {
      var searchResultWithoutThreshold = this.initialLoadTemplates.filter(
        (t: TemplateWrapper) =>
          (this.searchHeight.value == ''
            ? true
            : t.die.Height.toString().includes(this.searchHeight.value)) &&
          (this.searchWidth.value == ''
            ? true
            : t.die.Width.toString().includes(this.searchWidth.value)) &&
          this.getShapesForFilter().includes(t.die.Shape)
      );

      var searchResultWithThreshold = this.initialLoadTemplates.filter(
        (t: TemplateWrapper) =>
          (this.searchHeight.value == ''
            ? true
            : Number(t.die.Height) >=
                Number(this.searchHeight.value) - this.sizeSearchThreshold &&
              Number(t.die.Height) <=
                Number(this.searchHeight.value) + this.sizeSearchThreshold) &&
          (this.searchWidth.value == ''
            ? true
            : Number(t.die.Width) >=
                Number(this.searchWidth.value) - this.sizeSearchThreshold &&
              Number(t.die.Width) <=
                Number(this.searchWidth.value) + this.sizeSearchThreshold) &&
          this.getShapesForFilter().includes(t.die.Shape)
      );

      console.log('finished filtering, now sorting by width...');
      searchResultWithoutThreshold.sort(
        (a, b) => Number(a.die.Width) - Number(b.die.Width)
      );
      searchResultWithThreshold.sort((a, b) => Number(a.die.Width) - Number(b.die.Width));
      console.log('finished sorting.');

      searchResultWithThreshold = searchResultWithThreshold.filter(
        x => !searchResultWithoutThreshold.includes(x)
      );

      this.currentlyDisplayedTemplates = searchResultWithoutThreshold.concat(
        searchResultWithThreshold
      );
    }
  }

  async DownloadDieTemplates(item: any) {
    try {
      await DieService.DownloadDieTemplates(item);
    } catch (err) {
      console.log('error with DownloadDieTemplates');
    }
  }

  /* Mounted */
  async mounted() {
    this.getTemplates(this.dies);
    this.SearchTemplates();
  }

  /* Created */
  async created() {
    //this.convertDiesToDataTemplates();
  }
}
